import { defineComponent as _defineComponent } from 'vue'
import * as validation from 'JS/components/blain-form/validation';
import bugsnagClient from 'JS/global/bugsnag';
import Icon from 'JS/components/Icon.vue';
import ProgressSpinner from 'Src/js/components/ProgressSpinner.vue';
import { BSelect, BTextField } from 'Src/js/components/blain-form';
import { debounce } from 'JS/utilities/debounce';
import { FormatOptions } from 'JS/components/blain-form/formatting';
import { IAccountAddressService, VerifyZipResponse } from 'JS/services/AccountAddressService';
import { inject, onMounted, ref } from 'vue';
import { inputLabelVariantInjectionKey } from 'JS/components/blain-form/input-label-variant';


export default /*#__PURE__*/_defineComponent({
  __name: 'ZipAddressInput',
  props: {
    zip: null,
    city: null,
    state: null,
    zipError: null,
    loading: { type: Boolean },
    disabled: { type: Boolean }
  },
  emits: ["update:zip", "update:city", "update:state", "update:zipError", "update:loading", "unknown-error"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'update:zip', value: string): void;
	(e: 'update:city', value: string): void;
	(e: 'update:state', value: string): void;
	(e: 'update:zipError', value: string): void;
	(e: 'update:loading', value: boolean): void;
	(e: 'unknown-error', error: any): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	zip?: string;
	city?: string;
	state?: string;
	zipError?: string;
	loading?: boolean;
	disabled?: boolean;
}





function handleUpdateCity(city: string | number) {
	emit('update:city', city as string);
}

const zipCities = ref<string[]>([]);

const zipFormat: FormatOptions = {
	type: 'numeric',
	length: 5,
};

function clearError() {
	emit('update:zipError', '');
}

function onZipInput(zip: string) {
	if (props.zip?.length === 5 && zip.length < 5) {
		emit('update:state', "");
		emit('update:city', "");
		zipCities.value = [];
	}

	emit('update:zip', zip);
	//entered the last digit of a 5 digit zip code
	if (props.zip !== zip && zip.length === 5) {
		verifyAndUpdateCitiesDebounced(zip);
	}
}

const accountAddressService = inject<IAccountAddressService>('AccountAddressService');
const injectedLabelVariant = inject(inputLabelVariantInjectionKey, null);
const verifyAndUpdateCitiesDebounced = debounce(500, (zip: string) => verifyAndUpdateCities(zip));
async function verifyAndUpdateCities(zip: string) {
	emit('update:loading', true);

	let response: VerifyZipResponse | null = null;
	try {
		response = await accountAddressService.verifyZip(zip);
	} catch (e) {
		bugsnagClient.notify(e);
		emit('unknown-error', e);
		emit('update:zipError', 'Something went wrong.');
	}

	emit('update:loading', false);

	if (response == null) {
		emit('update:zipError', 'Something went wrong.');
		return;
	}

	if (response.success === false) {
		emit('update:zipError', response.message);
		return;
	}

	clearError();
	zipCities.value = response.cities;
	emit('update:state', response.state);

	if (zipCities.value.length === 1 || !zipCities.value.includes(props.city)) {
		emit('update:city', zipCities.value[0]);
	}
}

onMounted(() => {
	if (props.city) {
		zipCities.value.push(props.city);
	}
	if (props.zip) {
		verifyAndUpdateCities(props.zip);
	}
});

return { __sfc: true,props, emit, handleUpdateCity, zipCities, zipFormat, clearError, onZipInput, accountAddressService, injectedLabelVariant, verifyAndUpdateCitiesDebounced, verifyAndUpdateCities, validation, Icon, ProgressSpinner, BSelect, BTextField }
}

})